<template>
  <div>
    <v-alert outlined type="info">
      Sets are compositions of multiple containers / holds / trailers / pallets - like a
      <strong>{{ $setNames(base_type) }}</strong>
    </v-alert>
    <sets-library-component :setType="$route.params.type">
      <template v-slot:items="{ paginatedItems: sets }">
        <v-expansion-panels focusable class="unselectable">
          <v-expansion-panel
            v-for="set in sets"
            :key="set.id"
            @click="$vuetify.goTo($event.target)">
            <v-expansion-panel-header>
              <span>
                <strong>
                  <span>
                    <v-icon v-if="!set.default">mdi-account</v-icon>
                    {{ set.name }}
                  </span>
                </strong>
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <scene-component
                :setType="set.data"
                :canvas-width="300"
                :canvas-height="150"></scene-component>
              <v-btn
                v-if="!set.default && user.is_editor"
                @click="
                  $router.push({
                    name: 'modify_set',
                    params: {
                      set_id: set.id,
                      type: set.base_type,
                    },
                  })
                "
                block>
                <v-icon>mdi-pencil</v-icon>Edit
              </v-btn>
              <v-btn
                v-else
                @click="
                  $router.push({
                    name: 'modify_set',
                    params: {
                      set_id: set.id,
                      type: set.base_type,
                    },
                  })
                "
                block>
                <v-icon>mdi-magnify-plus-outline</v-icon>View
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </sets-library-component>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import containerLibraryComponent from '@/components/Custom/ContainerLibrary.vue';
import setsLibraryComponent from '@/components/Custom/SetsLibrary.vue';

import sceneComponent from '@/components/Custom/SceneComponent.vue';
import { mapStores } from 'pinia';
import { useMiscStore } from '@/stores/miscStore';
import { ListType } from '@/models/LoadlistModel';
import { User } from '@/models/UserCompanyModel';
export default Vue.extend({
  name: 'equipment',
  components: {
    containerLibraryComponent,
    setsLibraryComponent,
    sceneComponent,
  },
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMiscStore),
    user(): User {
      return this.miscStore.user;
    },
    base_type(): ListType {
      return (this.$route.params.type as ListType) || 'SEA';
    },
  },
  methods: {},
  filters: {},
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
